
import { Vue } from 'vue-property-decorator';
export default class InitialNetworkError extends Vue {}
